import React, {Component} from "react";
import dateFns from "date-fns";
import {cx, addClassName} from "../lib/ClassSet";
import {Map} from "immutable";
import "./Calendar.css";

class Calendar extends Component {

  renderHeader() {
    const dateFormat = "MMMM YYYY";

    let currentMonth = dateFns.format(this.props.currentMonth, dateFormat);

    return (
      <div className="header row flex-middle">
        <div className="col col-start">
          <div className="icon" onClick={this.prevMonth}>
            <div className="icon">&lt;</div>
          </div>
        </div>
        <div className="col col-center">
          <span>{currentMonth}</span>
        </div>
        <div className="col col-end" onClick={this.nextMonth}>
          <div className="icon">&gt;</div>
        </div>
      </div>
    );
  }

  renderDays() {
    const dateFormat = "dddd";
    const days = [];

    let startDate = dateFns.startOfWeek(this.props.currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          {dateFns.format(dateFns.addDays(startDate, i), dateFormat)}
        </div>
      );
    }

    return <div className="days row">{days}</div>;
  }

  renderCells() {
    const { currentMonth, selectedDate, unavailableDates, notBeforeDate, notAfterDate, showEvents } = this.props;
    const monthStart = dateFns.startOfMonth(currentMonth);
    const monthEnd = dateFns.endOfMonth(monthStart);
    const startDate = dateFns.startOfWeek(monthStart);
    const endDate = dateFns.endOfWeek(monthEnd);

    const dateFormat = "D";
    const isoDateFormat = "YYYY-MM-DD";
    const rows = [];

    const useNotBeforeDate = notBeforeDate != null;
    const useNotAfterDate = notAfterDate != null;

    let days = [];
    let day = startDate;
    let formattedDate = "";
    let formattedIsoDate = "";

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = dateFns.format(day, dateFormat);
        formattedIsoDate = dateFns.format(day, isoDateFormat);
        let isUnavailable = unavailableDates.has(formattedIsoDate);
        if (!isUnavailable && useNotBeforeDate && dateFns.isBefore(day, notBeforeDate)) isUnavailable = true;
        if (!isUnavailable && useNotAfterDate && dateFns.isAfter(day, notAfterDate)) isUnavailable = true;
        const cloneDay = day;
        let event = null;
        if (showEvents && unavailableDates.has(formattedIsoDate)) {
          event = (
            <span className="event">{unavailableDates.get(formattedIsoDate)}</span>
          )
        }
        let classes = `col cell weekday-${i+1}`;
        classes = addClassName(isUnavailable, classes, "unavailable");
        classes = addClassName(!dateFns.isSameMonth(day, monthStart), classes, "disabled");
        classes = addClassName(dateFns.isSameDay(day, selectedDate), classes, "selected");
        days.push(
          <div className={classes}
            key={day}
            onClick={() => this.onDateClick(dateFns.parse(cloneDay))}
            onDoubleClick={() => this.onDateDoubleClick(dateFns.parse(cloneDay))}>
            <span className="number">{formattedDate}</span>
            {event}
          </div>
        );
        day = dateFns.addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  }

  onDateClick = day => {
    if (this.props.onSelect) {
      this.props.onSelect(day);
    }    
  };

  onDateDoubleClick = day => {
    if (this.props.onConfirm) {
      this.props.onConfirm(day);
    }
  };

  nextMonth = () => {
    this.props.onSetCurrentMonth(dateFns.addMonths(this.props.currentMonth, 1))
  };

  prevMonth = () => {
    this.props.onSetCurrentMonth(dateFns.subMonths(this.props.currentMonth, 1))
  };

  render() {
    let classes = cx({
      "Calendar": true,
      "u-weekends-disabled": this.props.disableWeekends
    })
    return (
      <div className={classes}>
        {this.renderHeader()}
        {this.renderDays()}
        {this.renderCells()}
      </div>
    );
  }
}

Calendar.defaultProps = {
  unavailableDates: Map(),
  disableWeekends: false,
  selectedDate: new Date(),
  currentMonth: new Date(),
  notBeforeDate: null,
  notAfterDate: null,
  showEvents: true
}

export default Calendar;